var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.isBusy, rounded: "sm", "spinner-small": false } },
        [
          _c(
            "form",
            {
              attrs: { id: "submitPasswordForgotForm" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.doSubmit()
                },
              },
            },
            [
              _c("h3", [_vm._v("Recover Password")]),
              _vm._v(
                "\n      If you are an Agent user and you have forgotten your password, enter\n      your registered email address into the box below and press submit.\n\n      "
              ),
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.emailReset,
                            expression: "emailReset",
                          },
                        ],
                        ref: "emailFormField",
                        staticClass: "form-control form-control-lg",
                        attrs: { id: "agent-recover-password", type: "text" },
                        domProps: { value: _vm.emailReset },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.emailReset = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "bottom-section" }, [
                _c("div", { staticClass: "paypoint-link" }, [
                  _c(
                    "a",
                    {
                      attrs: { id: "back-to-login-form" },
                      on: {
                        click: function ($event) {
                          return _vm.backToLoginPageClickHandler()
                        },
                      },
                    },
                    [_vm._v("Back to Login")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "login-button" },
                  [
                    _c(
                      "ButtonNew",
                      {
                        attrs: {
                          buttonId: "PasswordResetButton",
                          variant: "search",
                          type: "submit",
                          isDisabled: _vm.isDisabledCallback(this.emailReset),
                          datacy: "submit-forgot-password-form-button",
                        },
                      },
                      [_vm._v("\n            Send E-Mail\n          ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }